var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AfterSalesPolicy"},[(_vm.imgSales != null)?_c('div',[_c('img',{attrs:{"src":_vm.imgSales,"alt":"","width":"100%","height":"100%"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }